import styled from 'styled-components/macro';

export const MainContainer = styled.div`
  margin: 61px 0 60px 208px;
  padding: 32px 112px;
  box-sizing: border-box;
`;
